import { showInformer } from '@ui/status-informer';

export async function responseErrorInterceptorNotification<Return = void>(
  props: IResponseErrorInterceptorNotificationProps<Return>,
  // @ts-ignore
): Promise<Return> {
  try {
    return await props.handler();
  } catch (err: Response | Error | any) {
    console.error(err);

    const isResponse = err instanceof Response;
    const body = isResponse ? await err.json() : err;

    showInformer({
      // @ts-ignore
      title: isResponse ? 'Ошибка' : err.message || 'Произошла ошибка',
      content: isResponse ? body.message : body.error || '',
      status: 'alert',
      timeout: 6000,
    });

    props.catchHandler?.(err, isResponse, body);
  }
}

export interface IResponseErrorInterceptorNotificationProps<Return = void> {
  handler: () => Promise<Return>;
  catchHandler?: (err: Response | Error | any, isResponse: boolean, body: any) => void;
}
